import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19d734c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "merchant-dropdown" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "text-weight-medium"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bx bx-chevron-down ml-1" }, null, -1))
const _hoisted_5 = {
  class: "merchant-dropdown__dropdown popover-container",
  "data-test": "selectMerchantDropdown"
}
const _hoisted_6 = { class: "my-3 text text-weight-medium text-gray-800" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-neutral-100 p-4 rounded-2 mr-4 text-md" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bx bx-chevron-down text-lg text-neutral-200 ml-auto" }, null, -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = ["data-test", "onClick"]
const _hoisted_11 = { class: "flex items-center w-full" }
const _hoisted_12 = { class: "flex flex-col" }
const _hoisted_13 = { class: "text text-weight-medium" }
const _hoisted_14 = { class: "text-sm" }
const _hoisted_15 = { class: "bx bx-chevron-down text-lg text-neutral-400 ml-auto" }
const _hoisted_16 = {
  key: 0,
  class: "merchant-dropdown__dropdown__item__divisions"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "bg-neutral-50 px-3 py-2 rounded-2 mr-4 text-neutral-500" }
const _hoisted_19 = { class: "flex flex-col" }
const _hoisted_20 = { class: "text text-weight-medium truncate title-max-width" }
const _hoisted_21 = { class: "text-sm" }

import { ref, nextTick, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useAllMerchantsStore } from '@apps/ops/src/store';
import { InputField } from '@ds/components';
import debounce from '@shared/utils/debounce';
import { Merchant, Division } from '@shared/api/merchants';
import { getMerchant } from '@shared/api/api';
import router from '../router';


export default /*#__PURE__*/_defineComponent({
  __name: 'MerchantDropdown',
  setup(__props) {

const route = useRoute();
const allMerchantsStore = useAllMerchantsStore();

/**
 * OPEN/CLOSE DROPDOWN
 */
const searchTerm = ref();
const inputContainer = ref<HTMLDivElement>();
const showDropdown = ref();

const updateMerchants = async () => {
	const haveMerchants = Object.values(allMerchantsStore.merchantsData).length > 0;

	const cachedSearchTerm = sessionStorage.getItem('merchantSearchTerm');
	searchTerm.value = selectedMerchant.value?.displayName || cachedSearchTerm || '';

	if (!haveMerchants && showDropdown.value) {
		await allMerchantsStore.getAllMerchants(searchTerm.value);
	}
};

const handleOpenDropdown = () => {
	showDropdown.value = !showDropdown.value;
	if (showDropdown.value) updateMerchants();
	nextTick(() =>
		(inputContainer.value?.querySelector('[data-ts*="input"]') as HTMLInputElement)?.focus()
	);
};

const handleClickOutside = () => {
	showDropdown.value = false;
	if (!selectedDivision.value) selectedMerchant.value = null;
};

const handleMerchantSearch = debounce((val) => {
	sessionStorage.setItem('merchantSearchTerm', JSON.stringify(val));
	allMerchantsStore.getAllMerchants(val as string);
}, 300);

/**
 * SELECT/CLEAR MERCHANT AND DIVISION
 */
const selectedMerchant = ref();
const selectedDivision = ref();
const showDivisions = ref();

const handleClickMerchant = (merchant: Merchant) => {
	if (merchant.divisions.length === 1) {
		selectedMerchant.value = merchant;
		handleClickDivision(merchant.divisions[0]);
	} else if (showDivisions.value && merchant?.code === selectedMerchant.value?.code) {
		showDivisions.value = false;
	} else {
		selectedMerchant.value = merchant;
		showDivisions.value = true;
	}
};

const handleClickDivision = async (division: Division) => {
	showDropdown.value = false;
	sessionStorage.setItem('merchantSearchTerm', selectedMerchant.value.displayName);
	searchTerm.value = selectedMerchant.value.displayName;
	selectedDivision.value = { code: division.code, displayName: division.displayName };

	router.replace({
		query: {
			merchantCode: selectedMerchant.value.code,
			divisionCode: selectedDivision.value.code,
		},
	});
};

const clearSelectedMerchant = () => {
	selectedMerchant.value = null;
	selectedDivision.value = null;
	sessionStorage.removeItem('merchantSearchTerm');
};

const handleClearInput = () => {
	clearSelectedMerchant();
	router.replace({ query: {} });

	allMerchantsStore.getAllMerchants();
	showDropdown.value = false;
};

watch(
	() => route?.query?.merchantCode,
	async () => {
		if (!route?.query?.merchantCode) {
			clearSelectedMerchant();
			return;
		}

		const merchant = await getMerchant(route.query.merchantCode.toString());
		selectedMerchant.value = merchant;
		selectedDivision.value = merchant?.divisions?.find(
			(division: Division) => division.code === route.query.divisionCode
		);
	},
	{ immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "merchant-dropdown__btn",
      "data-test": "selectMerchantButton",
      onClick: handleOpenDropdown
    }, [
      (!selectedDivision.value?.displayName)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('ops.selectMerchant.selectMerchantPlaceholder')), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(selectedDivision.value.displayName), 1)),
      _hoisted_4
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        ref_key: "inputContainer",
        ref: inputContainer,
        class: "sticky top-0 pt-2 pb-4 mb-4 bg-white"
      }, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('ops.selectMerchant.searchLabel')), 1),
        _createVNode(_unref(InputField), {
          value: searchTerm.value,
          placeholder: _ctx.$t('ops.selectMerchant.searchPlaceholder'),
          "is-search": "",
          "alt-style": "",
          "show-clear-btn": "",
          onClearInput: handleClearInput,
          onInput: _unref(handleMerchantSearch)
        }, null, 8, ["value", "placeholder", "onInput"])
      ], 512),
      (_unref(allMerchantsStore).loading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (i) => {
            return _createElementVNode("div", {
              key: i,
              class: "flex items-center w-full bg-neutral-50 p-3 rounded-2 m-2 py-4 animate-bg"
            }, _hoisted_9)
          }), 64))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList((_unref(allMerchantsStore).merchantsData! as Merchant[]), (merchant, i) => {
            return (_openBlock(), _createElementBlock("button", {
              key: merchant.code,
              class: _normalizeClass([
						'merchant-dropdown__dropdown__item',
						{
							'merchant-dropdown__dropdown__item--active':
								merchant.code === selectedMerchant.value?.code,
						},
					]),
              "data-test": `selectMerchantDropdownOption-${i}`,
              onClick: _withModifiers(($event: any) => (handleClickMerchant(merchant)), ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: _normalizeClass([
								'bg-neutral-100 px-4 py-3 rounded-2 mr-4 text-md',
								{ 'bg-neutral-50': merchant.code === selectedMerchant.value?.code },
							])
                }, _toDisplayString(merchant?.displayName.substring(0, 1).toUpperCase()), 3),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(merchant?.displayName), 1),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(merchant?.code), 1)
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_15, null, 512), [
                  [_vShow, merchant?.divisions?.length > 1]
                ])
              ]),
              (
							(showDivisions.value ||
							selectedMerchant.value?.divisions.some(
								(div) => div.code === selectedDivision.value?.code
							)) &&
								selectedMerchant.value?.code === merchant?.code
						)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedMerchant.value.divisions, (division) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: division?.code,
                        class: _normalizeClass([
								'merchant-dropdown__dropdown__item__divisions__item',
								{
									'merchant-dropdown__dropdown__item__divisions__item--active':
										selectedDivision.value?.code === division?.code,
								},
							]),
                        onClick: _withModifiers(($event: any) => (handleClickDivision(division)), ["stop"])
                      }, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(division?.displayName.substring(0, 1).toUpperCase()), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("p", _hoisted_20, _toDisplayString(division?.displayName), 1),
                          _createElementVNode("p", _hoisted_21, _toDisplayString(division?.code), 1)
                        ])
                      ], 10, _hoisted_17))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_10))
          }), 128))
    ], 512), [
      [_vShow, showDropdown.value]
    ])
  ])), [
    [_directive_click_outside, handleClickOutside]
  ])
}
}

})